import { render, staticRenderFns } from "./DataLoggerIdentifierAutocomplete.vue?vue&type=template&id=1bf57b36&scoped=true&"
import script from "./DataLoggerIdentifierAutocomplete.vue?vue&type=script&lang=js&"
export * from "./DataLoggerIdentifierAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf57b36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
